import { defineMessages } from 'react-intl'

const appMessages = defineMessages({
  securePayment: {
    id: 'securePayment',
    defaultMessage: 'Secure payment provided by Stripe.com'
  },
  coaching: {
    id: 'coaching',
    defaultMessage: 'Coaching'
  },
  becomeACoach: {
    id: 'becomeACoach',
    defaultMessage: 'Become a coach'
  },
  challenge: {
    id: 'challenge',
    defaultMessage: 'Challenge'
  },
  edit: {
    id: 'edit',
    defaultMessage: 'Edit'
  },
  close: {
    id: 'close',
    defaultMessage: 'Close'
  },
  giveFeedback: {
    id: 'giveFeedback',
    defaultMessage: 'Give Feedback'
  },
  shopNow: {
    id: 'shopNow',
    defaultMessage: 'Shop Now'
  },
  firstName: {
    id: 'firstName',
    defaultMessage: 'First Name'
  },
  lastName: {
    id: 'lastName',
    defaultMessage: 'Last Name'
  },
  password: {
    id: 'password',
    defaultMessage: 'Password'
  },
  account: {
    id: 'account',
    defaultMessage: 'account',
    description: 'The account.'
  },
  continue: {
    id: 'continue',
    defaultMessage: 'Continue'
  },
  gymaholicEmail: {
    id: 'gymaholicEmail',
    defaultMessage: 'contact@gymaholic.co'
  },
  contactUs: {
    id: 'contactUs',
    defaultMessage: 'Contact Us'
  },
  cancel: {
    id: 'cancel',
    defaultMessage: 'cancel',
    description: 'Cancel.'
  },
  duration: {
    id: 'duration',
    defaultMessage: 'duration',
    description: 'The duration.'
  },
  dontHaveAnAccount: {
    id: 'dontHaveAnAccount',
    defaultMessage: 'Don’t have an account?',
    description: 'The sign up label.'
  },
  email: {
    id: 'email',
    defaultMessage: 'Email',
    description: 'The account’s email.'
  },
  empty: {
    id: 'empty',
    defaultMessage: 'The {name} can’t be empty.',
    description: 'Used to validate an empty value.'
  },
  forgotPassword: {
    id: 'forgotPassword',
    defaultMessage: 'Forgot password?',
    description: 'The button used to navigate to the forgot password screen.'
  },
  getStarted: {
    id: 'getStarted',
    defaultMessage: 'Get Started',
    description: 'The button used to navigate to the forgot password screen.'
  },
  haveAnAccount: {
    id: 'haveAnAccount',
    defaultMessage: 'Have an account?',
    description: 'Used to toggle the log in mode.'
  },
  home: {
    id: 'home',
    defaultMessage: 'home',
    description: 'Home.'
  },
  month: {
    id: 'month',
    defaultMessage: 'month'
  },
  year: {
    id: 'year',
    defaultMessage: 'year'
  },
  invalid: {
    id: 'invalid',
    defaultMessage: 'The {name} is invalid.',
    description: 'Used to validate an invalid value.'
  },
  level: {
    id: 'level',
    defaultMessage: 'level',
    description: 'The level.'
  },
  long: {
    id: 'long',
    defaultMessage: 'The {name} is too long, use {max} characters maximum.',
    description: 'Used to validate a value that is too long.'
  },
  logIn: {
    id: 'logIn',
    defaultMessage: 'Log In',
    description: 'The label used to log in.'
  },
  ok: {
    id: 'ok',
    defaultMessage: 'OK',
    description: 'The label used to confirm.'
  },
  logOut: {
    id: 'logOut',
    defaultMessage: 'Log Out',
    description: 'The label used to log out.'
  },
  notOnline: {
    id: 'notOnline',
    defaultMessage: 'No Internet Connection',
    description: 'Displayed when there is no internet connection.'
  },
  notConnected: {
    id: 'notConnected',
    defaultMessage: 'The server is temporary unavailable, try again later.',
    description: 'Displayed when the user is not responding.'
  },
  seeAll: {
    id: 'seeAll',
    defaultMessage: 'See All',
    description: 'Used to validate a value that is too short.'
  },
  short: {
    id: 'short',
    defaultMessage: 'The {name} is too short, use at least {min} characters.',
    description: 'Used to validate a value that is too short.'
  },
  signUp: {
    id: 'signUp',
    defaultMessage: 'Sign Up',
    description: 'Used to sign up.'
  },
  futureAndDiscountPricing: {
    id: 'futureAndDiscountPricing',
    defaultMessage: '{futurePricing} {discountPricing}',
    description: 'The get premium title.'
  },
  free: {
    id: 'free',
    defaultMessage: 'Free',
    description: 'The get premium title.'
  },
  andMuchMore: {
    id: 'andMuchMore',
    defaultMessage: 'And much more...',
    description: 'The description of the workout section.'
  },
  more: {
    id: 'textExpandableMore',
    defaultMessage: 'more'
  },
  less: {
    id: 'textExpandableLess',
    defaultMessage: 'less'
  }
})

export const challengeMessages = defineMessages({
  title: {
    id: 'Challenge.title',
    defaultMessage: 'Challenge - Gymaholic'
  },
  contentMarkDown: {
    id: 'Challenge.contentMarkDown',
    defaultMessage: 'Challenge'
  },
  name: {
    id: 'Challenge.name',
    defaultMessage: '30-Day Lean & Strong Summer Challenge'
  },
  description: {
    id: 'Challenge.description',
    defaultMessage: 'Get fit, be more disciplined and eat healthier; not only for the summer, but for life!'
  },
  joinTheChallenge: {
    id: 'Challenge.joinTheChallenge',
    defaultMessage: 'Join The Challenge'
  },
  reviewHeading: {
    id: 'Challenge.ReviewHeading',
    defaultMessage: 'Reviews'
  },
  whatYouCanExpectHeading: {
    id: 'Challenge.WhatYouCanExpectHeading',
    defaultMessage: 'What you can expect'
  },
  whatYouCanExpectPoint2: {
    id: 'Challenge.whatYouCanExpectPoint1',
    defaultMessage: 'Eat healthy whether you’re at home or on vacation'
  },
  whatYouCanExpectPoint1: {
    id: 'Challenge.whatYouCanExpectPoint2',
    defaultMessage: 'Build a lean and strong body'
  },
  whatYouCanExpectPoint3: {
    id: 'Challenge.whatYouCanExpectPoint3',
    defaultMessage: 'Adapt your workout program according to your energy levels, schedule and equipment'
  },
  whatYouCanExpectPoint4: {
    id: 'Challenge.whatYouCanExpectPoint4',
    defaultMessage: 'Be more disciplined with your training, nutrition and your overall life'
  },
  whatYouCanExpectPoint5: {
    id: 'Challenge.whatYouCanExpectPoint5',
    defaultMessage: 'Sleep better and feel energized all day long'
  },
  faq1: {
    id: 'Challenge.faq1',
    defaultMessage: 'How long is the challenge?'
  },
  faqA1: {
    id: 'Challenge.faqA1',
    defaultMessage: '30 days'
  },
  faq0: {
    id: 'Challenge.faq0',
    defaultMessage: 'What fitness level is this for?'
  },
  faqA0: {
    id: 'Challenge.faqA0',
    defaultMessage: 'This challenge is available for all levels. Whether you’re beginner who need to lose weight and feel better or a more advanced athlete who want to build muscle - we’re here to help.'
  },
  faq2: {
    id: 'Challenge.faq2',
    defaultMessage: 'How many workouts per week?'
  },
  faqA2: {
    id: 'Challenge.faqA2',
    defaultMessage: 'Every day! Most workouts will challenge you, but others will also teach you the important of active recovery.'
  },
  faq3: {
    id: 'Challenge.faq3',
    defaultMessage: 'Do I need a gym access?'
  },
  faqA3: {
    id: 'Challenge.faqA3',
    defaultMessage: 'Not necessarily. Once you subscribe, you will receive daily workouts with different equipment options'
  },
  faqA3Point1: {
    id: 'Challenge.faqA3Point1',
    defaultMessage: 'No equipment'
  },
  faqA3Point2: {
    id: 'Challenge.faqA3Point2',
    defaultMessage: 'Gym access'
  },
  faqA3Point3: {
    id: 'Challenge.faqA3Point3',
    defaultMessage: 'Dumbbell'
  },
  faqA3Point4: {
    id: 'Challenge.faqA3Point4',
    defaultMessage: 'Resistance band'
  },
  faq4: {
    id: 'Challenge.faq4',
    defaultMessage: 'Is nutrition included?'
  },
  faqA4: {
    id: 'Challenge.faqA4',
    defaultMessage: 'Yes, you will receive weekly tips and recipes to help you eat healthier.'
  },
  faq5: {
    id: 'Challenge.faq5',
    defaultMessage: 'What if I need help?'
  },
  faqA5: {
    id: 'Challenge.faqA5',
    defaultMessage: 'You will get access to a exclusive chat with coaches and like-minded people that will answer your questions.'
  },
  faq6: {
    id: 'Challenge.faq6',
    defaultMessage: 'When does it start and end?'
  },
  faqA6: {
    id: 'Challenge.faqA6',
    defaultMessage: 'The 30-day challenge starts on Monday, June 20th 2022 and ends on Wednesday, July 20th 2022'
  },
  faq7: {
    id: 'Challenge.faq7',
    defaultMessage: 'How to access the challenge?'
  },
  faqA7: {
    id: 'Challenge.faqA7',
    defaultMessage: 'After subscribing to the challenge you will receive an email on how to install the Gymaholic App. Don’t hesitate to email us at contact@gymaholic.co, if you’re facing any issues.'
  },
  challengeText: {
    id: 'Challenge.ChallengeText',
    defaultMessage: 'With our 20+ years of experience combined, we built this challenge to provide you best results in 30 days!'
  },
  yourChoiceText: {
    id: 'Challenge.yourChoiceText',
    defaultMessage: 'But that’s only if you\'re willing to become the best version of yourself... and that\'s your choice.{br}{br}So if you\'ve been waiting for the "perfect" time to change your life, that moment is now!'
  },
  tryNewWorkoutSectionTitle: {
    id: 'Challenge.TryNewWorkoutSection.tryNewWorkoutSectionTitle',
    defaultMessage: 'What you get'
  },
  slide1Title: {
    id: 'Challenge.TryNewWorkoutSection.slide1.title',
    defaultMessage: 'Personalized workout program'
  },
  slide1Desc: {
    id: 'Challenge.TryNewWorkoutSection.slide1.desc',
    defaultMessage: 'Our daily workouts will help you get lean and empower you to best version of yourself. They will include gym, dumbbell, resistance band and bodyweight options. Get ready to look, move and feel better!'
  },
  slide2Title: {
    id: 'Challenge.TryNewWorkoutSection.slide2.title',
    defaultMessage: 'Coaching and community'
  },
  slide2Desc: {
    id: 'Challenge.TryNewWorkoutSection.slide2.desc',
    defaultMessage: 'Helping others is what keeps us going. We want to hear about your success story! And don’t hesitate to ask us question and tel us know what content you’d like to see.'
  },
  slide3Title: {
    id: 'Challenge.TryNewWorkoutSection.slide3.title',
    defaultMessage: 'Healthy nutrition, healthy life'
  },
  slide3Desc: {
    id: 'Challenge.TryNewWorkoutSection.slide3.desc',
    defaultMessage: 'Weekly nutrition tips and recipes to help you eat healthy, wether you’re at home or moving places during the summer. You’ll learn the importance of balance, and key principles like the 80/20 rule.'
  },
  challengeStartDate: {
    id: 'Challenge.challengeStartDate',
    defaultMessage: 'Starts: Monday, June 20th'
  },
  challengeEndDate: {
    id: 'Challenge.challengeStartingDate',
    defaultMessage: 'Ends: Wednesday, July 20th'
  }
})

export const creatorMessages = defineMessages({
  title: {
    id: 'Creator.title',
    defaultMessage: 'Creator - Gymaholic'
  },
  contentMarkDown: {
    id: 'Creator.contentMarkDown',
    defaultMessage: 'Creator'
  },
  bannerTitle: {
    id: 'Creator.Banner.title',
    defaultMessage: 'Sawyer Fitness'
  },
  bannerSubTitle: {
    id: 'Creator.Banner.subTitle',
    defaultMessage: 'I help busy women get toned & build confidence without tons of cardio '
  },
  button: {
    id: 'Creator.BannerButton.text',
    defaultMessage: 'Start Today'
  },
  aboutMe: {
    id: 'Creator.AboutMe',
    defaultMessage: 'About me'
  },
  plans: {
    id: 'Creator.Plan',
    defaultMessage: 'Plans'
  },
  features: {
    id: 'Creator.Profile.Features',
    defaultMessage: 'The features:'
  },
  about: {
    id: 'Creator.Profile.About',
    defaultMessage: 'About'
  },
  enterEmailToProceed: {
    id: 'Creator.enterEmailToProceed',
    defaultMessage: 'Enter your email to complete your purchase'
  },
  next: {
    id: 'Creator.next',
    defaultMessage: 'NEXT'
  }
})

export const completeWorkoutMessages = defineMessages({
  title: {
    id: 'CompleteWorkout.title',
    defaultMessage: 'Workout Completed'
  },
  subTitle: {
    id: 'CompleteWorkout.subTitle',
    defaultMessage: 'Let me know how was your training experience'
  },
  thankyouForFeedback: {
    id: 'CompleteWorkout.thankyouForFeedback',
    defaultMessage: 'Thank you for your feedback, what did you like the most:'
  },
  weAreHereToHelp: {
    id: 'CompleteWorkout.weAreHereToHelp',
    defaultMessage: 'We’re hear to help'
  },
  continue: {
    id: 'CompleteWorkout.continue',
    defaultMessage: 'Continue'
  },
  skip: {
    id: 'CompleteWorkout.skip',
    defaultMessage: 'Skip'
  },
  tellUs: {
    id: 'CompleteWorkout.tellUs',
    defaultMessage: 'Share your thoughts'
  },
  completed: {
    id: 'CompleteWorkout.completed',
    defaultMessage: 'Completed'
  },
  calories: {
    id: 'CompleteWorkout.calories',
    defaultMessage: 'Calories'
  },
  duration: {
    id: 'CompleteWorkout.duration',
    defaultMessage: 'Duration'
  },
  volume: {
    id: 'CompleteWorkout.volume',
    defaultMessage: 'Volume'
  },
  letMeKnow: {
    id: 'CompleteWorkout.letMeKnow',
    defaultMessage: 'Let {meOrUs} know how{tag}was your training experience'
  },
  tellYourFriends: {
    id: 'CompleteWorkout.tellYourFriends',
    defaultMessage: 'Tell your friends {tag} about your progress'
  }
})

export default appMessages
